<template>
  <div class="simplify">
    <h1>
      Official USPS<sup>®</sup> Change-of-Address
    </h1>
    <p class="simplify-header-paragraph">
      Save yourself a trip to the post office and forward your mail online in minutes.
    </p>
    <div class="simplify-hero">
      <simplify-hero-item header="Register to vote.">
        <span class="simplify-hero-item-paragraph">
          Confirm your new address and begin updating your <strong>voter
            registration</strong> here.
        </span>
      </simplify-hero-item>
      <div class="vertical-rule" />
      <simplify-hero-item header="Convenient.">
        <span class="simplify-hero-item-paragraph">
          Have your <strong>new address</strong> and <strong>mail forward
            start date</strong> on hand. You can always edit your address
          change if needed.
        </span>
      </simplify-hero-item>
      <div class="vertical-rule" />
      <simplify-hero-item header="Secure.">
        <span class="simplify-hero-item-paragraph">
          We will verify your identity using enhanced remote identity
          proofing and a valid debit or credit card. <strong>You will
            be charged $1.10 for this service.</strong>
        </span>
      </simplify-hero-item>
    </div>
  </div>
</template>

<script>
import SimplifyHeroItem from '../../components/ui/hero-items/simplify.vue';

export default {
  name: 'DisclaimerSimplify',
  components: { SimplifyHeroItem },
};
</script>
